// extracted by mini-css-extract-plugin
export default {"items_container":"page-videos_items_container__VZYta","item_wrapper":"page-videos_item_wrapper__i4QY0"};